import { service } from "@ember/service";
import { Ability } from "ember-can";

/**
 * Classic Ember class is used there because ability overload in parog does not
 * otherwise. The bug is not completely identified though.
 *
 * Note that Ability properties must be computed properties.
 * https://github.com/minutebase/ember-can/issues/83
 */
export default class PatientAbility extends Ability {
  /** @type { import("core/services/session").default } */
  @service session;

  get canCreate(): boolean {
    return !!this.session.medic;
  }

  get canEnroll(): boolean {
    return (
      this.session.medic &&
      this.session.medic.hasRole(
        "research_assistant",
        "medical_secretary",
        "doctor",
        "nurse",
        "nurse_lead",
        "retail_pharmacist"
      )
    );
  }

  get canEdit(): boolean {
    return !!this.session.medic;
  }
}
